import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks } from '../../types/my-types';

type IGroundTruthUpdateMutationParams = {
  trainingSetId: string;
};

export const useTrainingSetDelete = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IGroundTruthUpdateMutationParams) => {
      return await (await glynt).trainingSet.del(data.trainingSetId);
    },

    ...callbacks
  });
};
